var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.66406 1V2.40191",
    stroke: "#65717B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.34375 1V2.40191",
    stroke: "#65717B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.32117 1.5909H9.661C10.0104 1.5909 10.3455 1.72971 10.5926 1.97679C10.8397 2.22387 10.9785 2.55898 10.9785 2.9084V9.97665C10.9785 10.327 10.8393 10.6631 10.5915 10.9109C10.3438 11.1586 10.0077 11.2978 9.65732 11.2978H2.3175C1.96807 11.2978 1.63296 11.159 1.38589 10.9119C1.13881 10.6649 1 10.3297 1 9.98032V2.9084C0.999999 2.73507 1.0342 2.56345 1.10064 2.40337C1.16708 2.24328 1.26445 2.09788 1.38718 1.97549C1.50991 1.8531 1.65559 1.75613 1.81586 1.69013C1.97613 1.62414 2.14785 1.59042 2.32117 1.5909V1.5909Z",
    stroke: "#65717B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.00391 4.06808H11.0007",
    stroke: "#65717B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.9368f6f80f50fd12feda60fe8bfa6cc0.svg";
export { ForwardRef as ReactComponent };